// Saved previews support exactly one quote level; never recursively walk providers.
export const getWorkspaceUrlMetaEntries = message => (
    (Array.isArray(message?.urlMeta) ? message.urlMeta : []).flatMap((meta, index) => (
        [meta, meta?.quoted_url_meta].flatMap((entry, quoteIndex) => (
            entry && typeof entry === 'object' ? [{
                meta: entry,
                workspaceUrlMetaIndex: index,
                ...(quoteIndex ? { workspaceQuotedMeta: true } : {})
            }] : []
        ))
    ))
);
